import { FormikErrors } from "formik";
import React from "react";
import {
  ICandidateDetails,
  ICandidateReviewFormInput,
} from "../../../../store/superadmin/types";
import CustomButton from "../../../UI/Buttons/CustomButton";
import RightArrow from "../../../UI/Icons/RightArrow";
import CharacterLimitTextarea from "../../../UI/Inputs/CharacterLimitTextarea";
import Checkbox from "../../../UI/Inputs/Checkbox";
import ErrorMessage from "../../../UI/Tooltips/ErrorMessage";

interface IdVerificationProps {
  showIdVerification: boolean;
  reviewCandidateData: ICandidateDetails | null;
  values: ICandidateReviewFormInput;
  currentStage: number;
  errors: FormikErrors<ICandidateReviewFormInput>;
  skipIdVerification: number;
  setSkipIdVerification: (value: number) => void;
  setFieldValue: (field: string, value: string | number) => void;
  handleSectionNavigation: (nextStep: string) => void;
}

const IdVerification: React.FC<IdVerificationProps> = ({
  showIdVerification,
  reviewCandidateData,
  values,
  currentStage,
  errors,
  skipIdVerification,
  setSkipIdVerification,
  setFieldValue,
  handleSectionNavigation,
}) => {
  const connectIdData = reviewCandidateData?.connect_id_data
    ? reviewCandidateData?.connect_id_data
    : null;

  const handleChange = (data: string) => {
    setFieldValue("id_verification_bypass_reason", data);
  };

  const handleMoveNext = () => {
    handleSectionNavigation("onlineInterview");
  };

  const isStage1Submitted = reviewCandidateData?.profile?.current_stage === 1;

  return (
    
      <div
        className={`d-flex flex-column gap-20 fw-400 text-black ${
          showIdVerification ? "" : "d-none"
        }`}
      >
        <div className="fs-22 fw-500">ID Verification</div>
        {reviewCandidateData?.is_connectid_verified === null ? (
          <>
            <div className="fs-16">This step has not been completed.</div>

            {
              isStage1Submitted && (
              <div className="d-flex">
                <div className="bg-off-white p-15px radius-8px d-flex flex-column gap-12 w-100 max-w-420px">
                  <div className="fs-13 fw-700">Super Admin Control</div>
                  <div className="theme-check">
                    <Checkbox
                      className="theme-check-input"
                      id={"bypass_id_verification"}
                      checked={
                        values.bypass_id_verification === 1 ||
                        reviewCandidateData?.profile?.bypass_id_verification === 1
                      }
                      onChange={() => {
                        const newValue = skipIdVerification === 0 ? 1 : 0;
                        setSkipIdVerification(newValue);
                        setFieldValue("bypass_id_verification", newValue);
                      }}
                      label={"Allow employee to bypass this requirement"}
                      themeCheck={true}
                      labelFontSize="13"
                      labelBold={false}
                      disabled={
                        currentStage !== 1 ||
                        // reviewCandidateData?.profile?.interview_complete_later !== 1 &&
                        (reviewCandidateData?.profile?.review_status === null &&
                          reviewCandidateData?.profile?.current_stage === null)
                      }
                    />
                    {errors && (
                      <ErrorMessage
                        message={String(errors.bypass_id_verification ?? "")}
                      />
                    )}
                  </div>
                  <CharacterLimitTextarea
                    maxLength={200}
                    placeholder="Enter reason..."
                    value={
                      values.id_verification_bypass_reason ??
                      reviewCandidateData?.profile?.step_bypass_reason?.find(
                        (type) => type.bypass_type === "bypass_id_verification"
                      )?.reason ??
                      ""
                    }
                    onChange={(value) => handleChange(value)}
                    disabled={
                      currentStage !== 1
                        ? true
                        : values?.bypass_id_verification === 1
                        ? false
                        : true
                    }
                    doneBy={
                      reviewCandidateData?.profile?.step_bypass_reason?.length
                        ? reviewCandidateData.profile.step_bypass_reason.find(
                            (type) =>
                              type.bypass_type === "bypass_id_verification"
                          )
                        : undefined
                    }
                    error={
                      typeof errors.id_verification_bypass_reason === "string"
                        ? errors.id_verification_bypass_reason
                        : undefined
                    }
                  />
                </div>
              </div>
             )
            }
            { (reviewCandidateData?.profile?.review_status === "waiting" &&
              reviewCandidateData?.profile?.current_stage === 1 && 
              reviewCandidateData.completion_status.online_interview === 0) ? 
                <CustomButton 
                  type="submit"
                  variant="primary"
                  className="btn-theme bg-teal text-black max-w-100px text-nowrap"
                  onClick={handleMoveNext}
                  disabled={!values?.id_verification_bypass_reason?.trim()}
                >
                  Next 
                  <RightArrow color="#000000" />
                </CustomButton> : "" }
          </>
        ) : (
          <div className="fs-16 fw-600">Connect ID Verified</div>
        )}

        {reviewCandidateData?.is_connectid_verified !== null && (
          <>
            <div className="fs-20 fw-500">Basic Details</div>

            <div className="d-flex gap-40 flex-wrap">
              <div className="d-flex flex-column gap-2">
                <div className="fs-13 text-grey-medium">Given Name</div>
                <div className="fs-16">
                  {connectIdData?.claims?.given_name ?? "No data"}
                </div>
              </div>

              <div className="d-flex flex-column gap-2">
                <div className="fs-13 text-grey-medium">Middle Name</div>
                <div className="fs-16">
                  {connectIdData?.claims?.middle_name ?? "No data"}
                </div>
              </div>

              <div className="d-flex flex-column gap-2">
                <div className="fs-13 text-grey-medium">Family Name</div>
                <div className="fs-16">
                  {connectIdData?.claims?.family_name ?? "No data"}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
   
  );
};

export default IdVerification;
